/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const ASSIGN_TO_REALM = 'Assign to Blue Yonder User Store';
export const ASSIGN = 'Assign';
export const DO_YOU_WANT_TO_ASSIGN = 'Do you want to assign';
export const TO_THIS_REALM = 'to Blue Yonder User Store?';
export const CANCEL_BTN_TEXT = 'Cancel';
export const ASSIGN_TO_REALM_SUCCESS = 'Password policy {0} successfully assigned to Blue Yonder User Store.';
export const ASSIGN_TO_REALM_ERROR = 'Error while assigning password policy to Blue Yonder User Store';
